module.exports = __webpack_public_path__ + "static/images/MBA-2.016b7db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/MBA-2.png
// module id = DKE6
// module chunks = 8